import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookRendererMessagingService = ( createDecorator('INotebookRendererMessagingService'));
export { INotebookRendererMessagingService };
